import Mock from 'mockjs'

const mockData = Mock.mock({
  'data|3-6': [{
    'name': '@NAME',
    'creatDate': '@DATE',
    'address': '@CITY',
    'zip': '@ZIP'
  }]
})

export default {
  data: null,
  columns: [
    {
      label: '姓名',
      prop: 'userName'
    },
    {
      label: '业务类型',
      prop: 'busType'
    },
    {
      label: '业务类别',
      prop: 'busCategory'
    },
    {
      label: '主办方',
      prop: 'orgName'
    },
    {
      label: '业务名称',
      prop: 'busName'
    },
    {
      label: '业务ID',
      prop: 'busCode'
    },
    {
      label: '业务状态',
      prop: 'busStatus'
    },
    {
        label: '缴纳时间',
        prop: 'payTime'
    },
    {
      label: '缴费类型',
      prop: 'type'
  },
  {
      label: '预付金额',
      prop: 'shallAmount'
    },
    {
        label: '实付金额',
        prop: 'payAmount'
    },
    {
        label: '缴费状态',
        prop: 'status'
    }
  ]
}
